export default __webpack_public_path__ + "static/media/provesional_restoration_upper_28_4@2x.200afc1c.png";